import React, { useState } from "react";

const LowerLoanAmount = ({
  id,
  isLowerLoanAmountOpen,
  closeLowerLoanAmount,
  lowerAmount,
  setLowerAmount,
  loanCustomer,
  handleCancelButtonClick,
}) => {
  const [formattedLowerAmount, setFormattedLowerAmount] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleAmountChange = (e) => {
    let value = e.target.value;
    // Remove non-digits
    const rawValue = value?.replace(/[^0-9]/g, "");

    const numericValue = rawValue ? Number(rawValue) : 0;
    const maxAmount = Number(loanCustomer?.loan_amount || 0);

    // Validation
    if (numericValue > maxAmount) {
      setErrorMessage(
        `Amount cannot exceed KES ${maxAmount.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`,
      );
    } else {
      setErrorMessage("");
    }

    // Format for display
    const formattedValue = rawValue
      ? new Intl.NumberFormat().format(rawValue)
      : "";

    setLowerAmount(rawValue); // clean value (e.g. "10000")
    setFormattedLowerAmount(formattedValue); // display (e.g. "10,000")
  };

  const handleConfirmButtonClick = () => {
    if (!errorMessage) {
      closeLowerLoanAmount();
    }
  };

  return (
    <>
      <div
        id={id}
        className={`${
          isLowerLoanAmountOpen ? "flex" : "hidden"
        } flex items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="flex items-center justify-center w-full">
          <div className="relative bg-white shadow-lg rounded-sm w-[90%] max-w-[58%] mx-auto">
            <div className="mb-4 mx-auto items-center justify-center">
              <div className="flex items-center justify-between">
                <div className="text-[#000000] font-bold text-[20px] ml-5">
                  <p>Lower Loan Amount</p>
                </div>
                <button
                  onClick={closeLowerLoanAmount}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm ml-auto inline-flex items-center "
                  data-modal-toggle={id}
                >
                  <svg
                    width="61"
                    height="43"
                    viewBox="0 0 61 43"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_13891_3896)">
                      <path
                        d="M32.84 28L30.7 24.9L28.9 28H25.2L28.88 22.3L25.1 16.84H28.94L31.08 19.92L32.88 16.84H36.58L32.84 22.46L36.68 28H32.84Z"
                        fill="black"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_13891_3896">
                        <rect width="61" height="43" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </button>
              </div>

              <div className="flex items-center mx-5">
                <p className="text-[15px] font-[300]">
                  You're approving a lower loan amount than requested. Enter the
                  new amount and provide a reason for
                  <br />
                  the adjustment before proceeding.
                </p>
              </div>

              <div className="flex flex-col mx-5 mt-10">
                <label
                  htmlFor="newLoanAmount"
                  className="mb-1 text-[16px] font-normal text-[#000000]"
                >
                  New Loan Amount
                </label>
                <div className="flex items-center w-[404px] h-10 rounded-[4px] border border-[1px] border-[#000]">
                  <div className="flex items-center justify-center text-[#000] w-[76px] h-10 font-normal border-r border-t border-b  border-[#000]">
                    KES
                  </div>
                  <input
                    type="text"
                    id="newLoanAmount"
                    name="lowerAmount"
                    placeholder="Enter New Loan Amount"
                    value={formattedLowerAmount}
                    onChange={handleAmountChange}
                    className="w-[328px] h-9 px-4"
                  />
                </div>

                {/* Error message */}
                {errorMessage && (
                  <div className="flex text-[#FF5757] text-[14px] font-[300] mt-1">
                    {errorMessage}
                  </div>
                )}
              </div>

              <div className="flex items-center mt-16 mx-5">
                <div className="mr-5">
                  <button
                    onClick={handleConfirmButtonClick}
                    data-modal-toggle={id}
                    type="button"
                    className="text-[#074073] font-[500] rounded-[5px] text-[16px] px-8 py-2 text-center 
                    bg-[#FFFFFF] border border-[#074073]"
                    disabled={!!errorMessage}
                  >
                    Confirm New Loan Amount
                  </button>
                </div>
                <button
                  onClick={handleCancelButtonClick}
                  data-modal-toggle={id}
                  type="button"
                  className="text-[#FF5757] bg-[#FFFFFF] hover:bg-[#FFFFFF] border border-[#FF5757] focus:outline-none font-[500] rounded-[5px] text-[16px] text-medium px-8 py-2 text-center"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LowerLoanAmount;
